import { CORE_CHAIN_TEST_ENTRIES, } from "./chain-matrix.js";
/** Pinned getTokenMetadata vectors — reads name/symbol/decimals/totalSupply at the chain's pinned block. */
export const ASSETS_TOKEN_METADATA_QUERY_VECTORS = CORE_CHAIN_TEST_ENTRIES.flatMap(([chain, config]) => config.tokenMetadataQuery
    ? [
        {
            chain,
            ...config.tokenMetadataQuery,
        },
    ]
    : []);
export const ASSETS_TOKEN_METADATA_QUERY_TEST_CHAINS = ASSETS_TOKEN_METADATA_QUERY_VECTORS.map((vector) => vector.chain);
/** Pinned getTokenAllowance vectors — VITALIK→DEAD_ADDRESS allowance (always 0) at the chain's pinned block. */
export const ASSETS_TOKEN_ALLOWANCE_QUERY_VECTORS = CORE_CHAIN_TEST_ENTRIES.flatMap(([chain, config]) => config.tokenAllowanceQuery
    ? [
        {
            chain,
            ...config.tokenAllowanceQuery,
        },
    ]
    : []);
export const ASSETS_TOKEN_ALLOWANCE_QUERY_TEST_CHAINS = ASSETS_TOKEN_ALLOWANCE_QUERY_VECTORS.map((vector) => vector.chain);
/** Per-chain getPortfolio vectors (no fixture — schema-only, pricing data is live). */
export const ASSETS_PORTFOLIO_QUERY_VECTORS = CORE_CHAIN_TEST_ENTRIES.flatMap(([chain, config]) => config.portfolioQuery
    ? [
        {
            chain,
            ...config.portfolioQuery,
        },
    ]
    : []);
export const ASSETS_PORTFOLIO_QUERY_TEST_CHAINS = ASSETS_PORTFOLIO_QUERY_VECTORS.map((vector) => vector.chain);
